export {
  SeriesIntroductionCard,
  type SeriesIntroductionCardProps,
} from "./SeriesIntroductionCard";

export { apiToSeriesIntroductionCardProps } from "./apiToSeriesIntroductionProps";
